<template>
  <el-dialog
    :visible="show"
    @update:visible="updateVisiable($event)"
    :title="lan.hint"
    width="410px"
    :top="top"
    :show-close="true"
    class="hint_dialog"
  >
    <el-dialog
      class="hint_dialog"
      width="450px"
      :title="lan.hint"
      top="30vh"
      :visible.sync="innerVisible"
      @close="closeDialog"
      append-to-body>
      <div class="wait_hint" style="margin-bottom: 20px">
        {{message}}
      </div>
    </el-dialog>

    <div class="wait_hint">
      {{lan.wait}}
    </div>
    <div class="wait_btn">
      <el-button
        @click="handleConfirm"
        style="width: 120px;height: 40px;background-color: #f4a100;font-size: 14px;border: none;color: #ffffff"
      >{{lan.lineWait}}
      </el-button>
      <el-button
        @click="updateVisiable(false)"
        style="width: 120px;height: 40px;background-color: #cccccc;font-size: 14px;border: none;color: #ffffff"
      >{{lan.cancel}}
      </el-button>
    </div>
  </el-dialog>
</template>

<script>
  import {getWait} from "../../api/webSocket";
  export default {
    props: {
      top: {
        type: String,
        default: "30vh"
      },
      show: {
        type: Boolean,
        default: false
      },
      waitData: {
        type: Object,
        default: () => {}
      },
      lan: {
        type: Object,
        default: () => {}
      },
      lanState: {
        type: String
      }
    },
    data() {
      return {
        innerVisible: false,
        message: ""
      }
    },
    methods: {
      updateVisiable(v) {
        this.$emit("update:show", v);
      },
      closeDialog() {
        this.updateVisiable(false)
      },
      handleConfirm() {
        getWait(this.waitData).then(res => {
          if (this.lanState == "ch"){
            this.message = res.text;
            this.innerVisible = true;
          }else {
            this.message = res.text_en;
            this.innerVisible = true;
          }
        })
        this.$emit("updateData")
      }
    }
  }
</script>
<style>
  .inner_dialog .el-dialog{
    padding: 20px !important;
  }
  .inner_dialog .el-dialog__header{
    padding: 0 !important;
    border-bottom: 1px solid #a1a1a1 !important;
  }
  .inner_dialog .el-dialog__body{
    padding: 0 !important;
  }
  .inner_dialog .el-dialog__title {
    font-size: 14px;
  }
</style>
<style scoped>
.wait_hint {
  text-align: center;
  color: #424242;
  font-size: 18px;
  margin-top: 35px;
}
  .wait_btn {
    text-align: center;
    margin-top: 40px;
  }
.el-button+.el-button {
  margin-left: 40px !important;
}
.el-message-box__title {
  padding-bottom: 10px !important;
  border-bottom: 1px solid #a1a1a1 !important;
}
</style>